import React, { useContext, useEffect, useState } from 'react';
import theme from '@ifca-root/react-component/src/assets/theme';
import { Footer } from '@ifca-root/react-component/src/components/Footer/Footer';
import DynamicSubHeader from '@ifca-root/react-component/src/components/Header/DynamicSubHeader';
import { ExcelInput } from '@ifca-root/react-component/src/components/Input/ExcelUploadInput';
import {
  CircularProgress,
  List,
  ListItem,
  ListItemText,
  useMediaQuery,
} from '@material-ui/core';
import SnackBarContext from 'containers/App/Store/SnackBarContext';
import { useLocation, useParams } from 'react-router-dom';
import { formatDate } from 'helpers/StringNumberFunction/FormatDate';
import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader';
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper';
import Loading from '@ifca-root/react-component/src/components/Loading/Loading';
import { useHistory } from 'react-router';
import { CommonDialog } from '@ifca-root/react-component/src/components/Dialog/CommonDialog';
import { useExcelUploadVersion2 } from '@ifca-root/react-component/src/utils/hooks/excelUploadVersion2';
import {
  useCreateItemExcelMutation,
  useGetItemImportCheckingValidationLazyQuery,
  useGetItemImportCheckingValidationQuery,
  useImportItemExcelMutation,
} from '../../../generated/graphql';
import { ItemExcelInput } from './ItemImportExcelDialog';
import InfiniteScroll from 'react-infinite-scroll-component';
import { ErrorDialog } from 'components/Dialog/ErrorDialog';
import { SystemMsgs } from 'helpers/Messages/SystemMsg';

export const ItemImportExcelValidation = (props: any) => {
  const { module } = props;
  let location = useLocation();
  const passedData: any = location?.state;
  const fileName = passedData.fileTitle;
  let history = useHistory();
  const { BatchID }: any = useParams();
  let user = JSON.parse(localStorage.getItem('loggedInUser'));
  const { setOpenSnackBar, setSnackBarMsg }: any = useContext(
    SnackBarContext as any,
  );
  const [validatedData, setValidatedData] = useState<any>({
    ErrorData: [],
    ValidData: [],
  });
  const [openUpload, setOpenUpload] = useState(null);
  const [openDialog, setOpenDialog] = useState(null);
  const [errMessage, setErrMessage] = useState(null);
  const [errDialog, setErrDialog] = useState(false);

  let validationPath;
  let backPath;
  let itemLabel;
  let moduleLabel;
  switch (module) {
    case 'GP':
      validationPath = `/general-purchase/general-setting/item-category/import-item-validation/${BatchID}`;
      backPath = '/general-purchase/general-setting/item-category';
      itemLabel = 'Purchase Item';
      moduleLabel = 'General Purchase';
      break;
    case 'AP':
      validationPath = `/account-payable/general-setting/item-submenu/import-item-validation/${BatchID}`;
      backPath = '/account-payable/general-setting/item-submenu';
      itemLabel = 'Item';
      moduleLabel = 'Account Payable';
      break;
    case 'IC':
      validationPath = `/inventory-control/general-setting/stock-item/import-item-validation/${BatchID}`;
      backPath = '/inventory-control/general-setting/stock-item';
      itemLabel = 'Stock Item';
      moduleLabel = 'Inventory Control';
      break;
  }

  const [
    loadData,
    {
      loading: ItemImportCheckingValidationLoading,
      error: getItemImportCheckingValidationError,
      data: { getItemImportCheckingValidation } = {
        getItemImportCheckingValidation: [],
      },
    },
  ] = useGetItemImportCheckingValidationLazyQuery({
    fetchPolicy: 'network-only',
    onError: ({ message }) => {
      let error = message?.substring(15);
      setErrMessage(error);
      setErrDialog(true);
    },
    onCompleted: ({ getItemImportCheckingValidation }) => {
      if (getItemImportCheckingValidation?.Data?.length > 0) {
        let ErrorData: any = [];
        let ValidData: any = [];

        getItemImportCheckingValidation?.Data?.map(x => {
          if (x['err_status'] === true)
            ErrorData.push({
              ItemCategory: x['ItemCategory'],
              ItemName: x['ItemName'],
              Description: x['Description'],
              UOMCode: x['UOMCode'],
              TaxSchemeName: x['TaxSchemeName'],
              MasterCOACode: x['MasterCOACode'],
              Remark: x['Remark'],
              IsAP: x['IsAP'],
              IsGP: x['IsGP'],
              VariancePercentage: x['VariancePercentage'],
              MarketPrice: x['MarketPrice'],
              LatestPurchasePrice: x['LatestPurchasePrice'],
              DefaultSupplier: x['DefaultSupplier'],
              IsCentralised: x['IsCentralised'],
              IsInventory: x['IsInventory'],
              ABCClass: x['ABCClass'],
              ShelfLife: x['ShelfLife'],
              StandardCost: x['StandardCost'],
              RowNo: x['RowNo'],
              ErrorList: x['err_remarks'],
            });
          else
            ValidData.push({
              ItemCategory: x['ItemCategory'],
              ItemName: x['ItemName'],
              Description: x['Description'],
              UOMCode: x['UOMCode'],
              TaxSchemeName: x['TaxSchemeName'],
              MasterCOACode: x['MasterCOACode'],
              Remark: x['Remark'],
              IsAP: x['IsAP'],
              IsGP: x['IsGP'],
              VariancePercentage: x['VariancePercentage'],
              MarketPrice: x['MarketPrice'],
              LatestPurchasePrice: x['LatestPurchasePrice'],
              DefaultSupplier: x['DefaultSupplier'],
              IsCentralised: x['IsCentralised'],
              IsInventory: x['IsInventory'],
              ABCClass: x['ABCClass'],
              ShelfLife: x['ShelfLife'],
              StandardCost: x['StandardCost'],
              RowNo: x['RowNo'],
              ErrorList: x['err_remarks'],
            });
        });

        setValidatedData({
          ErrorData: [...validatedData.ErrorData, ...ErrorData],
          ValidData: [...validatedData.ValidData, ...ValidData],
        });
      }
    },
  });

  const [
    ImportItemExcel,
    { loading: ImportItemExcelLoading, error: createError },
  ] = useImportItemExcelMutation({
    onError: ({ message }) => {
      let error = message?.substring(15);
      setErrMessage(error);
      setErrDialog(true);
      resetFileUpload();
      setFileTitle('');
      setCurrentData([]);
      setOpenUpload(false);
    },
    onCompleted: data => {
      resetFileUpload();
      setFileTitle('');
      setCurrentData([]);
      setOpenUpload(false);
      setValidatedData({ ErrorData: [], ValidData: [] });
      loadData({
        variables: {
          BatchID: BatchID ?? passedData?.BatchID,
          take: 30,
          skip: 0,
        },
      });
      history.push({
        pathname: validationPath,
        state: {
          BatchID: BatchID,
          fileTitle: fileTitle,
        },
      });
    },
  });

  const [
    ConfirmUpload,
    { loading: CreateItemExcelLoading, error: confirmUploadError },
  ] = useCreateItemExcelMutation({
    onError: ({ message }) => {
      let error = message?.substring(15);
      setErrMessage(error);
      setErrDialog(true);
    },
    onCompleted: data => {
      resetFileUpload();
      setFileTitle('');
      setCurrentData([]);
      setOpenUpload(false);
      history.push({
        pathname: backPath,
      });
      setSnackBarMsg(SystemMsgs.createNewRecord);
      setOpenSnackBar(true);
    },
  });

  useEffect(() => {
    loadData({
      variables: {
        BatchID: BatchID ?? passedData?.BatchID,
        take: 30,
        skip: 0,
      },
    });
  }, []);

  const {
    openFileUpload,
    setOpenFileUpload,
    fileTitle,
    setFileTitle,
    openSnackBar,
    //setOpenSnackBar,
    snackBarMessage,
    setSnackBarMessage,
    currentData,
    setCurrentData,
    onDownloadTemplate,
    onSelectFile,
    duplicateItems,
    errorDialog: duplicateErrorDia,
    setErrorDialog,
    resetFileUpload,
  } = useExcelUploadVersion2();

  const isDesktop = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  const onImport = data => {
    ImportItemExcel({
      variables: {
        BatchID: BatchID,
        ItemExcelImportInput: data?.map(x => {
          return {
            BatchID: BatchID,
            ItemCategory: x?.ItemCategory === '' ? null : x?.ItemCategory,
            ItemName: x?.ItemName === '' ? null : x?.ItemName,
            Description: x?.Description === '' ? null : x?.Description,
            UOMCode: x?.UOMCode === '' ? null : x?.UOMCode,
            TaxSchemeName: x?.TaxSchemeName === '' ? null : x?.TaxSchemeName,
            MasterCOACode: x?.GLAccountCode === '' ? null : x?.GLAccountCode,
            Remark: x?.Remark === '' ? null : x?.Remark,
            IsAP:
              x?.IsAP === 'true' || x?.IsAP === 'True' || x?.IsAP === 'TRUE'
                ? true
                : x?.IsAP === 'false' || x?.IsAP === 'FALSE'
                ? false
                : x?.IsAP,
            IsGP:
              x?.IsGP === 'true' || x?.IsGP === 'True' || x?.IsGP === 'TRUE'
                ? true
                : x?.IsGP === 'false' || x?.IsGP === 'FALSE'
                ? false
                : x?.IsGP,
            VariancePercentage:
              x?.VariancePercentage === ''
                ? null
                : Number(x?.VariancePercentage),
            MarketPrice: x?.MarketPrice === '' ? null : Number(x?.MarketPrice),
            DefaultSupplier:
              x?.DefaultSupplier === '' ? null : x?.DefaultSupplier,
            IsCentralised:
              x?.IsCentralised === 'true' ||
              x?.IsCentralised === 'True' ||
              x?.IsCentralised === 'TRUE'
                ? true
                : x?.IsCentralised === 'false' || x?.IsCentralised === 'FALSE'
                ? false
                : x?.IsCentralised,
            IsInventory:
              x?.IsInventory === 'true' ||
              x?.IsInventory === 'True' ||
              x?.IsInventory === 'TRUE'
                ? true
                : x?.IsInventory === 'false' || x?.IsInventory === 'FALSE'
                ? false
                : x?.IsInventory,
            ABCClass: x?.ABCClass === '' ? null : x?.ABCClass,
            ShelfLife: x?.ShelfLife === '' ? null : Number(x?.ShelfLife),
            StandardCost:
              x?.StandardCost === '' ? null : Number(x?.StandardCost),
            RowNo: x?.rowNo,
          };
        }),
      },
    });
  };

  const onConfirm = () => {
    ConfirmUpload({ variables: { BatchID } });
  };

  return (
    <>
      {ItemImportCheckingValidationLoading && <Loading />}
      {ImportItemExcelLoading && <Loading />}
      {CreateItemExcelLoading && <Loading />}
      <MainHeader
        mainBtn="close"
        onClick={() => history.push(backPath)}
        smTitle={moduleLabel}
        title={user?.accountName}
        routeSegments={[
          { name: 'Main Menu' },
          { name: itemLabel, current: true },
        ]}
      />

      <DynamicSubHeader
        style={{
          marginTop: '-2px',
        }}
        title={`${itemLabel} Excel Upload`}
        rightText={<span className="c-orange">Validation</span>}
      />
      <List className="search-header fixed-search-header with-dynamic">
        <ListItem>
          <ListItemText
            primary={
              <>
                <span className="xsTitle flex-space">{fileName}</span>
              </>
            }
          />
        </ListItem>
      </List>

      <ContentWrapper
        style={{ marginTop: isDesktop ? '140px' : '75px' }}
        float
        footer
      >
        <InfiniteScroll
          dataLength={
            validatedData?.ErrorData?.length + validatedData?.ValidData?.length
          }
          next={() => {
            loadData({
              variables: {
                BatchID: BatchID ?? passedData?.BatchID,
                skip:
                  validatedData?.ErrorData?.length +
                  validatedData?.ValidData?.length,
                take: 30,
              },
            });
          }}
          hasMore={true}
          className=""
          style={{ padding: '8px 6px' }}
          loader={
            ItemImportCheckingValidationLoading && (
              <div style={{ textAlign: 'center' }}>
                {' '}
                <CircularProgress />{' '}
              </div>
            )
          }
          endMessage={
            <p style={{ textAlign: 'center' }}>
              <b>-</b>
            </p>
          }
        >
          {/* Problem List */}
          {validatedData.ErrorData?.length > 0 && (
            <>
              <List style={{ marginBottom: '-13px' }}>
                <ListItem>
                  <ListItemText
                    primary={
                      <>
                        <span
                          className="xsTitle"
                          style={{ marginLeft: '-9px' }}
                        >
                          Problem{' '}
                          {
                            <>
                              (
                              <span className="highlight-text">
                                {getItemImportCheckingValidation?.ProblemCount}
                              </span>
                              )
                            </>
                          }
                        </span>
                      </>
                    }
                  />
                </ListItem>
              </List>
              <List className="core-list">
                {validatedData.ErrorData?.map((el, index) => (
                  <ListItem key={index}>
                    <ListItemText
                      // style={{
                      //   textAlign: 'right',
                      //   marginLeft: '5px',
                      // }}
                      primary={
                        <>
                          <div style={{ width: '100%' }}>
                            <div>
                              <span className="xsTitle flex-space ">
                                ItemCategory:{' '}
                              </span>
                              <span className="mdDesc flex-space ">
                                {el.ItemCategory}{' '}
                              </span>
                            </div>

                            <div>
                              <span className="xsTitle flex-space ">
                                ItemName:{' '}
                              </span>
                              <span className="mdDesc flex-space ">
                                {el.ItemName}{' '}
                              </span>
                            </div>

                            <div>
                              <span className="xsTitle flex-space ">
                                Description:{' '}
                              </span>
                              <span className="mdDesc flex-space ">
                                {el.Description}{' '}
                              </span>
                            </div>

                            <div>
                              <span className="xsTitle ">UOMCode: </span>
                              <span className="mdDesc ">
                                {el.UOMCode}
                                {' | '}{' '}
                              </span>
                              <span className="xsTitle ">TaxSchemeName: </span>
                              <span className="mdDesc ">
                                {el.TaxSchemeName} {' | '}{' '}
                              </span>
                              <span className="xsTitle ">MasterCOACode: </span>
                              <span className="mdDesc ">
                                {el.MasterCOACode}
                              </span>
                            </div>

                            <div>
                              <span className="xsTitle flex-space ">
                                Remark:{' '}
                              </span>
                              <span className="mdDesc flex-space ">
                                {el.Remark}{' '}
                              </span>
                            </div>

                            <div>
                              <span className="xsTitle ">IsAP: </span>
                              <span className="mdDesc ">
                                {el.IsAP === true ? 'True' : 'False'}
                                {' | '}{' '}
                              </span>
                              <span className="xsTitle ">IsGP: </span>
                              <span className="mdDesc ">
                                {el.IsGP === true ? 'True' : 'False'}
                                {' | '}{' '}
                              </span>
                              <span className="xsTitle ">IsCentralised: </span>
                              <span className="mdDesc ">
                                {el.IsCentralised === true ? 'True' : 'False'}
                                {' | '}{' '}
                              </span>
                              <span className="xsTitle ">IsInventory: </span>
                              <span className="mdDesc ">
                                {el.IsInventory === true ? 'True' : 'False'}
                              </span>
                            </div>

                            <div>
                              <span className="xsTitle ">
                                VariancePercentage:{' '}
                              </span>
                              <span className="mdDesc ">
                                {el.VariancePercentage}
                                {' | '}{' '}
                              </span>
                              <span className="xsTitle ">MarketPrice: </span>
                              <span className="mdDesc ">
                                {el.MarketPrice}
                                {' | '}{' '}
                              </span>
                              <span className="xsTitle ">
                                LatestPurchasePrice:{' '}
                              </span>
                              <span className="mdDesc ">
                                {el.LatestPurchasePrice}
                                {' | '}{' '}
                              </span>
                            </div>

                            <div>
                              <span className="xsTitle flex-space ">
                                DefaultSupplier:{' '}
                              </span>
                              <span className="mdDesc flex-space ">
                                {el.DefaultSupplier}{' '}
                              </span>

                              <div>
                                <span className="xsTitle ">ABCClass: </span>
                                <span className="mdDesc ">
                                  {el.ABCClass}
                                  {' | '}{' '}
                                </span>
                                <span className="xsTitle ">ShelfLife: </span>
                                <span className="mdDesc ">
                                  {el.ShelfLife}
                                  {' | '}{' '}
                                </span>
                                <span className="xsTitle ">StandardCost: </span>
                                <span className="mdDesc ">
                                  {el.StandardCost}
                                </span>
                              </div>
                            </div>
                          </div>
                        </>
                      }
                      secondary={
                        <>
                          <div>
                            <div
                              className="xsTitle text-noflow"
                              style={{ color: 'red' }}
                            >
                              {' '}
                              Row No: {el.RowNo}
                            </div>
                            <div
                              className="xsTitle text-noflow"
                              style={{ color: 'red' }}
                            >
                              {el.ErrorList}
                            </div>
                          </div>
                        </>
                      }
                    />
                  </ListItem>
                ))}
              </List>
            </>
          )}

          {/* Validation List */}
          {validatedData.ValidData?.length > 0 && (
            <>
              <List style={{ marginBottom: '-13px' }}>
                <ListItem>
                  <ListItemText
                    primary={
                      <>
                        <span
                          className="xsTitle"
                          style={{ marginLeft: '-9px' }}
                        >
                          Validated{' '}
                          {
                            <>
                              (
                              <span className="highlight-text">
                                {getItemImportCheckingValidation?.ValidCount}
                              </span>
                              )
                            </>
                          }
                        </span>
                      </>
                    }
                  />
                </ListItem>
              </List>
              <List className="core-list">
                {validatedData.ValidData?.map((el, index) => (
                  <ListItem key={index}>
                    <ListItemText
                      // style={{
                      //   textAlign: 'right',
                      //   marginLeft: '5px',
                      // }}
                      primary={
                        <>
                          <div style={{ width: '100%' }}>
                            <div>
                              <span className="xsTitle flex-space ">
                                ItemCategory:{' '}
                              </span>
                              <span className="mdDesc flex-space ">
                                {el.ItemCategory}{' '}
                              </span>
                            </div>

                            <div>
                              <span className="xsTitle flex-space ">
                                ItemName:{' '}
                              </span>
                              <span className="mdDesc flex-space ">
                                {el.ItemName}{' '}
                              </span>
                            </div>

                            <div>
                              <span className="xsTitle flex-space ">
                                Description:{' '}
                              </span>
                              <span className="mdDesc flex-space ">
                                {el.Description}{' '}
                              </span>
                            </div>

                            <div>
                              <span className="xsTitle ">UOMCode: </span>
                              <span className="mdDesc ">
                                {el.UOMCode}
                                {' | '}{' '}
                              </span>
                              <span className="xsTitle ">TaxSchemeName: </span>
                              <span className="mdDesc ">
                                {el.TaxSchemeName} {' | '}{' '}
                              </span>
                              <span className="xsTitle ">MasterCOACode: </span>
                              <span className="mdDesc ">
                                {el.MasterCOACode}
                              </span>
                            </div>

                            <div>
                              <span className="xsTitle flex-space ">
                                Remark:{' '}
                              </span>
                              <span className="mdDesc flex-space ">
                                {el.Remark}{' '}
                              </span>
                            </div>

                            <div>
                              <span className="xsTitle ">IsAP: </span>
                              <span className="mdDesc ">
                                {el.IsAP === true ? 'True' : 'False'}
                                {' | '}{' '}
                              </span>
                              <span className="xsTitle ">IsGP: </span>
                              <span className="mdDesc ">
                                {el.IsGP === true ? 'True' : 'False'}
                                {' | '}{' '}
                              </span>
                              <span className="xsTitle ">IsCentralised: </span>
                              <span className="mdDesc ">
                                {el.IsCentralised === true ? 'True' : 'False'}
                                {' | '}{' '}
                              </span>
                              <span className="xsTitle ">IsInventory: </span>
                              <span className="mdDesc ">
                                {el.IsInventory === true ? 'True' : 'False'}
                              </span>
                            </div>

                            <div>
                              <span className="xsTitle ">
                                VariancePercentage:{' '}
                              </span>
                              <span className="mdDesc ">
                                {el.VariancePercentage}
                                {' | '}{' '}
                              </span>
                              <span className="xsTitle ">MarketPrice: </span>
                              <span className="mdDesc ">
                                {el.MarketPrice}
                                {' | '}{' '}
                              </span>
                              <span className="xsTitle ">
                                LatestPurchasePrice:{' '}
                              </span>
                              <span className="mdDesc ">
                                {el.LatestPurchasePrice}
                                {' | '}{' '}
                              </span>
                            </div>

                            <div>
                              <span className="xsTitle flex-space ">
                                DefaultSupplier:{' '}
                              </span>
                              <span className="mdDesc flex-space ">
                                {el.DefaultSupplier}{' '}
                              </span>

                              <div>
                                <span className="xsTitle ">ABCClass: </span>
                                <span className="mdDesc ">
                                  {el.ABCClass}
                                  {' | '}{' '}
                                </span>
                                <span className="xsTitle ">ShelfLife: </span>
                                <span className="mdDesc ">
                                  {el.ShelfLife}
                                  {' | '}{' '}
                                </span>
                                <span className="xsTitle ">StandardCost: </span>
                                <span className="mdDesc ">
                                  {el.StandardCost}
                                </span>
                              </div>
                            </div>
                          </div>
                        </>
                      }
                    />
                  </ListItem>
                ))}
              </List>
            </>
          )}
        </InfiniteScroll>
      </ContentWrapper>

      <Footer
        options={
          validatedData.ErrorData?.length === 0 &&
          validatedData.ValidData?.length > 0
            ? [
                {
                  onClick: () => {
                    setOpenDialog(true);
                  },
                  name: 'Confirm Upload',
                  color: 'primary',
                },
              ]
            : [
                {
                  name: 'Re-upload',
                  color: 'primary',
                  onClick: () => {
                    setOpenUpload(true);
                  },
                },
              ]
        }
      />

      <ItemExcelInput
        showDupErrors={false}
        duplicateItems={duplicateItems}
        errorDia={duplicateErrorDia}
        setErrorDia={setErrorDialog}
        openUpload={openUpload}
        setOpenUpload={setOpenUpload}
        upload={fileTitle}
        template={currentData}
        setTemplate={setCurrentData}
        setUpload={setFileTitle}
        resetFileUpload={resetFileUpload}
        showFooter={false}
        reUpload={true}
        onUploadTemplate={() => {
          onImport(currentData);
          console.log('currentData', currentData);
          setOpenUpload(false);
        }}
        onSelectFile={(e: any) => {
          onSelectFile({ event: e });
        }}
        onDownloadTemplate={onDownloadTemplate}
        snackBarProps={{
          openSnackBar: openSnackBar,
          snackBarMessage: 'test',
          setOpenSnackBar: setOpenSnackBar,
          onClickButton: () => {
            setOpenSnackBar(false);
          },
        }}
      />

      <CommonDialog
        fullWidth={true}
        open={openDialog}
        onClose={() => {
          setOpenDialog(false);
        }}
        sections={{
          header: {
            dynamic: (
              <div className="">
                <div className="dialog-dynamic-content">
                  <span
                    className="title c-orange flex-space"
                    style={{
                      fontSize: '13px',
                      fontWeight: 'bold',
                    }}
                  >
                    Upload Confirmation
                  </span>
                </div>
              </div>
            ),
          },
          body: () => (
            <div>
              <span>{'Are you sure to upload?'}</span>
            </div>
          ),

          footer: {
            actions: [
              {
                displayText: 'Cancel',
                props: {
                  onClick: () => {
                    setOpenDialog(false);
                  },
                  variant: 'contained',
                  color: 'primary',
                },
              },
              {
                displayText: 'Confirm',
                props: {
                  onClick: () => {
                    onConfirm();
                  },
                  variant: 'contained',
                  color: 'primary',
                },
              },
            ],
          },
        }}
      />
      <ErrorDialog
        errorDia={errDialog}
        setErrorDia={setErrDialog}
        errorMsg={errMessage}
        errorHeaderMsg={'Error!'}
      />
    </>
  );
};
